import {
  AuthInfo,
  UserProfile,
} from 'src/app/core/models/user-profile.model';

export type LoadingState = 'idle' | 'pending' | 'success' | 'error';

export interface ResetPasswordState {
  status: LoadingState;
  error: string | null;
  lastEmailAttempt: string | null;
}

export interface ChangePasswordState {
  status: LoadingState;
  error: string | null;
}

export interface ChangeEmailState {
  status: LoadingState;
  error: string | null;
}

export interface UserState {
  authInfo: AuthInfo | null;
  authInitialized: boolean;
  profile: UserProfile | null;
  previousProfile: UserProfile | null;
  loading: boolean;
  error: string | null;
  resetPassword: ResetPasswordState;
  changePassword: ChangePasswordState;
  changeEmail: ChangeEmailState;
}

export const initialState: UserState = {
  authInfo: null,
  authInitialized: false,
  profile: null,
  previousProfile: null,
  loading: false,
  error: null,
  resetPassword: {
    status: 'idle',
    error: null,
    lastEmailAttempt: null,
  },
  changePassword: {
    status: 'idle',
    error: null,
  },
  changeEmail: {
    status: 'idle',
    error: null,
  },
};
